export default "__VITE_ASSET__8f9c0d3a__"